import { render, staticRenderFns } from "./myApproval.vue?vue&type=template&id=7f95d9d6&scoped=true&"
import script from "./myApproval.vue?vue&type=script&lang=js&"
export * from "./myApproval.vue?vue&type=script&lang=js&"
import style0 from "./myApproval.vue?vue&type=style&index=0&id=7f95d9d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f95d9d6",
  null
  
)

export default component.exports